<app-header></app-header>
<!-- <app-content></app-content> -->

<div class="about-us-one">
  <div class="banner-overlay">
    <div class="container">
      <!-- <div class="row">
        <div class="col-12">
            <span class="about-us-one-item">{{"privacyDescOne"|translate}}</span>
        </div>
      </div> -->
    </div>
  </div>
</div>
<div class="container pb-30">
  <div class="row">
    <div class="col-12">
      <h2 class="about-us-one-item">{{ "privacyPolicy" | translate }}</h2>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <span class="about-us-two-item">{{ "privacyDescOne" | translate }}</span>
    </div>
  </div>

  <div class="privacy-table mt-50 justify-content-center" *ngIf="!this.show">
    <div class="privacy-tbl-overlay">
      <div class="row">
        <div class="col-lg-4 col-sm-12" style="border-right: 2px solid #fff">
          <div class="row justify-content-center">
            <div class="priv-td-col col-8 justify-content-center">
              <img src="/assets/img/privacy/analytics.png" />
            </div>
          </div>
          <div class="row">
            <div class="priv-td-col">
              <span>{{ "privacyTblOne" | translate }}</span>
            </div>
          </div>
        </div>

        <div class="col-lg-4 col-sm-12" style="border-right: 2px solid #fff">
          <div class="row justify-content-center">
            <div class="priv-td-col col-8 justify-content-center">
              <img src="/assets/img/privacy/trust.png" />
            </div>
          </div>
          <div class="row">
            <div class="priv-td-col">
              <span>{{ "privacyTblTwo" | translate }}</span>
            </div>
          </div>
        </div>

        <div class="col-lg-4 col-sm-12">
          <div class="row justify-content-center">
            <div class="priv-td-col col-8 justify-content-center">
              <img src="/assets/img/privacy/secure-shield.png" />
            </div>
          </div>
          <div class="row">
            <div class="priv-td-col">
              <span>{{ "privacyTblThree" | translate }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="privacy-table justify-content-center" *ngIf="this.show">
    <div class="privacy-tbl-overlay">
      <div class="row justify-content-center">
        <div class="col-sm-11">
          <div class="row priv-td-row" style="border-bottom: 2px solid #fff">
            <div class="col-sm-3 justify-content-center img-container">
              <img src="/assets/img/privacy/analytics.png" />
            </div>
            <div class="col-sm-9 text-container">
              <span>{{ "privacyTblOne" | translate }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="row justify-content-center">
        <div class="col-sm-11">
          <div class="row priv-td-row" style="border-bottom: 2px solid #fff">
            <div class="col-sm-9 text-container">
              <span>{{ "privacyTblTwo" | translate }}</span>
            </div>
            <div class="col-sm-3 justify-content-center img-container">
              <img src="/assets/img/privacy/trust.png" />
            </div>
          </div>
        </div>
      </div>

      <div class="row justify-content-center">
        <div class="col-sm-11">
          <div class="row priv-td-row">
            <div class="col-sm-3 justify-content-center img-container">
              <img src="/assets/img/privacy/secure-shield.png" />
            </div>
            <div class="col-sm-9 text-container">
              <span>{{ "privacyTblThree" | translate }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row marg">
    <div class="col-12">
      <span class="about-us-two-item">{{ "privacyDescTwo" | translate }}</span>
    </div>
  </div>

  <div class="row justify-content-center">
    <div class="col-lg-12 col-sm-11">
      <div class="privacy-table-two mt-50 justify-content-center">
        <div class="privacy-tbl-overlay">
          <div class="row justify-content-center big-row">
            <div
              class="col-6 priv-td-col justify-content-center"
              style="
                border-right: 2px solid #fff;
                border-bottom: 2px solid #fff;
              "
            >
              <div class="row justify-content-center">
                <img src="/assets/img/privacy/personal-information.png" />
              </div>
              <div class="row justify-content-center">
                <div class="col-lg-10 col-sm-12">
                  <span>{{ "policyTblOne" | translate }}</span>
                </div>
              </div>
            </div>
            <div
              class="priv-td-col col-6 justify-content-center col-right"
              style="border-bottom: 2px solid #fff"
            >
              <div class="row justify-content-center">
                <img src="/assets/img/privacy/bill.png" />
              </div>
              <div class="row justify-content-center">
                <div class="col-lg-10 col-sm-12">
                  <span>{{ "policyTblTwo" | translate }}</span>
                </div>
              </div>
            </div>
          </div>

          <div class="row justify-content-center pb-20 big-row">
            <div class="priv-td-col col-6" style="border-right: 2px solid #fff">
              <div class="row justify-content-center">
                <img src="/assets/img/privacy/ip.png" />
              </div>
              <div class="row justify-content-center">
                <div class="col-lg-10 col-sm-12">
                  <span>{{ "policyTblThree" | translate }}</span>
                </div>
              </div>
            </div>
            <div class="priv-td-col col-6 col-right">
              <div class="row justify-content-center">
                <img src="/assets/img/privacy/file.png" />
              </div>
              <div class="row justify-content-center">
                <div class="col-lg-10 col-sm-12">
                  <span>{{ "policyTblFour" | translate }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row marg">
    <div class="col-12">
      <span class="about-us-two-item">{{
        "privacyDescThree" | translate
      }}</span>
    </div>
  </div>
  <div class="privacy-table-three mt-50">
    <div class="privacy-tbl-overlay">
      <div class="row pt-60 pb-60">
        <div class="col-12">
          <span>
            {{ "privacyInfoOne" | translate }}
          </span>
          <span>
            {{ "privacyInfoTwo" | translate }}
          </span>
          <span>
            {{ "privacyInfoThree" | translate }}
          </span>
          <span>
            {{ "privacyInfoFour" | translate }}
          </span>
          <span>
            {{ "privacyInfoFive" | translate }}
          </span>
        </div>
      </div>
    </div>
  </div>
  <div class="row marg">
    <div class="col-12">
      <span class="about-us-two-item">{{ "privacyDescFour" | translate }}</span>
    </div>
  </div>
  <div class="privacy-table-four mt-50 justify-content-center">
    <div class="row justify-content-center">
      <div class="col-lg-4 col-sm-3"></div>
      <div class="col-lg-4 col-sm-6 justify-content-center">
        <div class="row justify-content-center">
          <img src="/assets/img/privacy/group-tbl.png" />
        </div>
      </div>
      <div class="col-lg-4 col-sm-3"></div>
    </div>
    <div class="row justify-content-center padd">
      <div class="col-lg-10 col-sm-10">
        <span>
          {{ "privWarnOne" | translate }}
        </span>
        <span>
          {{ "privWarnTwo" | translate }}
        </span>
        <span>
          {{ "privWarnThree" | translate }}
        </span>
        <span>
          {{ "privWarnFour" | translate }}
        </span>
        <span>
          {{ "privWarnFive" | translate }}
        </span>
        <span>
          {{ "privWarnSix" | translate }}
        </span>
      </div>
    </div>
  </div>
</div>

<!-- <div class="single-blog-standard  mt-30">
    <div class="blog-dteails-content blog-border">
        <div class="blog-details-written">
            <div class="written-content">
                <div class="section">
                    <h4 class="title">{{"privacyPolicy" | translate}}</h4>
                    <p> {{"privacyDetail" | translate}} </p>
                </div>

                <div class="section">
                    <h4 class="title">{{"platForm" | translate}}</h4>
                    <p> {{"platformDetail" | translate}} </p>
                </div>

                <div class="section">
                    <h4 class="title">{{"yourInfo" | translate}}</h4>
                    <p> {{"yourInfoDetail" | translate}} </p>
                </div>

                <div class="section">
                    <h4 class="title">{{"informationProtection" | translate}}</h4>
                    <p> {{"informationProtectionDetail" | translate}} </p>
                </div>

                <div class="section">
                    <h4 class="title">{{"makeChanges" | translate}}</h4>
                    <p> {{"makeChangesDetail" | translate}} </p>
                </div>
            </div>
        </div>
    </div>
</div> -->

<app-footer
  [layout]="classname"
  [logo]="ftlogo"
  [shape]="ftshape"
  [bgimage]="ftbgimage"
></app-footer>
